import React, { Component } from 'react';
import { connect } from 'react-redux';
import { View, StyleSheet} from 'react-native';
import { BaseModal, toggleDieticianModal} from '../ui';
import { translate } from 'react-i18next';
import { UserDataConsumer } from '../utils';
import { DieticianNutritionSource, NutritionGuide} from '../Nutrition/components';
import Theme from '../theme';
import { GoalCardWithFullDescription } from '../Bookings/components';
import { mappedTitles, mappedIcons } from '../WorkoutGoalAssistant/utils';
import { workoutProgramWithDescriptions } from 'fitbeat.gym-core';
import { ProgramType, IEnabledFeatures } from 'fitbeat.models';
import { enabledFeaturesSelector } from '../auth';
import { IAppStore } from '../HomeWorkouts';
import { TranslateProp } from '../common-types';

interface IProps {
  t: TranslateProp;
  isDieticianModalVisible: boolean;
  toggleDieticianModal: (visible: boolean) => void;
  user: {
    userProfile: {
      longTermGoal: string;
    };
  };
  enabledFeatures: IEnabledFeatures;
}

interface IGoalData {
  workoutTypes?: any;
  title?: string;
  icon?: React.ReactNode;
}

class LearnMoreAboutNutritionScreen extends Component<IProps> {
  private goalData: IGoalData;

  constructor(props: IProps) {
    super(props);
    this.goalData = this.findWorkoutTypes();
  }

  public findWorkoutTypes = () => {
    const { user: { userProfile }, enabledFeatures } = this.props;
    const userLongTermGoal =
      !userProfile || userProfile.longTermGoal === 'NotSet'
        ? ProgramType.GetStrongAndFitGoal
        : userProfile.longTermGoal;
    let title;
    let icon;
    const workoutTypes = workoutProgramWithDescriptions(enabledFeatures)
      .filter(({ programType }) => programType !== ProgramType.NotSet)
      .find(({ programType }) => {
        title = mappedTitles[programType];
        icon = mappedIcons[programType]({}, Theme.BLACK);
        return programType === userLongTermGoal;
      });
    return { workoutTypes, title, icon };
  }

  public render() {
    const {
      t,
      isDieticianModalVisible,
      toggleDieticianModal: handleToggleDietician,
      user: { userProfile },
    } = this.props;
    return (
      <View style={{ flex: 1, backgroundColor: Theme.WHITE, padding: 15}}>
        <BaseModal
          closeModal={() => handleToggleDietician(false)}
          title=''
          containerStyle={{ height: '100vh' }}
          isModalVisible={isDieticianModalVisible}
        >
          <View style={styles.modalContainer}>
            <DieticianNutritionSource isLoading={false} />
          </View>
        </BaseModal>
        <View>
          {this.goalData && (
            <View>
              <GoalCardWithFullDescription
                withArrow={false}
                isActive={false}
                key={this.goalData.title}
                title={this.goalData.title}
                icon={this.goalData.icon}
                subtitle={t('fitnessGoalNoColon')}
                containerStyle={styles.goalCardContainer}
                headingTextStyle={styles.goalCardHeadingTextStyle}
                subtitleStyle={styles.subtitleStyle}
              />
            </View>
          )}
          <View style={styles.horizontalSeparator} />
        </View>
        <NutritionGuide userProfile={userProfile} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
  },
  horizontalSeparator: {
    borderBottomWidth: 1,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
  goalCardContainer: {
    flex: 0,
    backgroundColor: Theme.WHITE,
    borderWidth: 0,
    padding: 0,
    margin: 0,
    marginVertical: 0,
  },
  goalCardHeadingTextStyle: {
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
    paddingVertical: 3,
  },
  subtitleStyle: {
    color: Theme.GREY_DARK,
    fontSize: 16,
  },
});

const mapStateToProps = (state: IAppStore) => ({
  enabledFeatures: enabledFeaturesSelector(state) as IEnabledFeatures,
  isDieticianModalVisible: state.ui.dieticianModalVisible,
});

const mapDispatchToProps = (dispatch: any) => ({
  toggleDieticianModal: (visible: boolean) => dispatch(toggleDieticianModal(visible)),
});

export default translate(['nutrition'], { wait: true })(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(LearnMoreAboutNutritionScreen)),
);
